'use client';

import 'swiper/css';

import { Swiper, SwiperSlide } from 'swiper/react';

import TabFilterItem from '@/app/(football)/[team]/_components/common/TabFilterItem';
import type { OriginalsName } from '@/store/server/common/originals/originals.dto';

interface PackFilterProps {
  packs: Array<{ label: string; packName: string; originalsName: OriginalsName }>;
  selectedPackName: string;
  onSelect: (packName: string, originalsName: OriginalsName) => void;
}

export default function PackFilter({ packs, selectedPackName, onSelect }: PackFilterProps) {
  return (
    <div className="relative overflow-hidden">
      <Swiper slidesPerView="auto" spaceBetween={12} className="w-full">
        {packs.map((pack) => (
          <SwiperSlide key={pack.packName} style={{ width: 'auto' }}>
            <TabFilterItem
              label={pack.label}
              isSelected={selectedPackName === pack.packName}
              onClick={() => onSelect(pack.packName, pack.originalsName)}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      {/* Right gradient overlay */}
      <div
        className="pointer-events-none absolute top-0 right-0 z-10 h-full w-[40px]"
        style={{
          background: 'linear-gradient(to right, transparent, var(--color-card-deco-filter-fade))',
        }}
      />
    </div>
  );
}
